/* eslint-disable @next/next/no-img-element */
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { styles } from './UiCartToastAdded.styles';

export interface UiCartToastAddedProps {
  src: string;
  subtitle: string;
  tabs: string[];
  openInNewTab?: boolean;
}

export function UiCartToastAdded({
  tabs,
  src,
  subtitle,
  openInNewTab = false
}: UiCartToastAddedProps) {
  const slots = styles();

  const t = useTranslations();

  return (
    <Link
      href="/cart/"
      {...(openInNewTab && { target: '_blank', rel: 'noopener noreferrer' })}
      className={slots.base()}
    >
      <div className={slots.imageWrapper()}>
        <img
          className={slots.image()}
          src={src}
          alt={subtitle}
        />
      </div>
      <div className={slots.contentWrapper()}>
        <div className={slots.content()}>
          <div className={slots.title()}>{t('addedToCart')}</div>
          <div
            className={slots.subtitle()}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
          <div className={slots.tabs()}>
            {tabs.map((tab) => (
              <div
                key={tab}
                className={slots.tab()}
              >
                {tab}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}
